import React from 'react'
import { useCourse, useLearningMaterials } from '../hooks';
import { useNavigate } from 'react-router-dom';
import { CourseListingText, emptyCourseText } from '../language';
import { MwcdLogoComopent, useAppScope } from 'master';
import { ErrorComponent, LoadingSpinner, PageLayout } from 'shared';
import { CourseSubGroupCard } from '../components/CourseSubGroupCard';
import ErrorImg from "assets/images/error-robot.png";

export const CourseSubGroupList = ({ type }) => {
    const [isOpen, setIsOpen] = React.useState(true);

    const { isMWCD, lanSettings } = useAppScope();
    const { selectedProgramName } = useLearningMaterials({ load: false, type });
    const { name, courseType, displayName, hasCourseGroup, hasSubGroups, subGroupName, subGroupList }
        = useCourse({ type });
    const { data } = subGroupList;

    const hasLearningMaterial = data?.length > 0;
    const navigate = useNavigate();

    const goToPreviousPage = () => {
        navigate(-1, { replace: true });
    };

    const isAssignment = courseType === 2;
    const isTheory = courseType === 0;
    const path = isAssignment
        ? "assignment"
        : isTheory
            ? "learningmaterials"
            : "practicals";

    const currentName = isAssignment
        ? `${CourseListingText.Assignment[lanSettings?.lan || "en"]}`
        : isTheory
            ? `${CourseListingText.LearningMaterials[lanSettings?.lan || "en"]}`
            : `${CourseListingText.LearningContent[lanSettings?.lan || "en"]}`;

    const breadcrumb = [
        { label: selectedProgramName, location: "/program" },
        {
            label: displayName ? displayName : currentName,
            location: hasCourseGroup ? `/program/${path}/coursegroup` : "",
        },
        {
            label: name,
        },
    ]

    const handleCourseSubGroup = (item) => {
        if (item) {
            sessionStorage.setItem("courseSubGroup", JSON.stringify(item));
            navigate(`/program/${path}/courseslist`);
        }
    };

    const titleEndComponent = [
        <div key="logo-group" className="logo-group">
            {isMWCD && (
                <MwcdLogoComopent customClass="logo-group-mwcd_PD marati_logo_empty_page" />
            )}
        </div>,
    ];

    if (subGroupList?.isPending || subGroupList?.isLoading) {
        return <LoadingSpinner />;
    }

    return (
        <PageLayout
            title={
                hasLearningMaterial
                    ? hasSubGroups
                        ? name || currentName
                        : displayName || currentName
                    : false
            }
            breadcrumb={breadcrumb}
            titleEndComponent={titleEndComponent}
            isPageEmpty={!hasLearningMaterial}
        >
            <div className="row">
                <div className="col-12">

                    {hasLearningMaterial ? (
                        <CourseSubGroupCard
                            name={name}
                            isOpen={isOpen}
                            setIsOpen={setIsOpen}
                            list={data}
                            handleCourseSubGroup={handleCourseSubGroup}
                        />
                    ) : (
                        <ErrorComponent
                            title={emptyCourseText.NoCourse[lanSettings?.lan || "en"]}
                            message={emptyCourseText.Message[lanSettings?.lan || "en"]}
                            image={ErrorImg}
                            btnLabel={emptyCourseText.GoBack[lanSettings?.lan || "en"]}
                            onClick={goToPreviousPage}
                        />
                    )}
                </div>
            </div>
        </PageLayout>
    )
}
